import moment from "moment";
import React from "react";

function RefundConfirmationOrderIdContainer({ data }) {
  const booking = data?.flightBooking;
  const airlinePnr = booking?.travelers
    ?.at(0)
    ?.pnrList?.map((pnr) => (pnr?.airlinePnr || "")?.toLocaleUpperCase())
    ?.filter((pnr) => Boolean(pnr))
    ?.join(" | ");

  return (
    <div className="w-full rounded-md border border-primary1/10 bg-primary1/5 mt-4">
      {/* Top blue rule */}
      <div className="h-1 w-full bg-primary1" />

      {/* Content */}
      <div className="p-3 sm:p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-4 items-start">
          <div>
            <div className="text-xs text-gray-500">Order date</div>
            <div className="mt-1 text-sm text-gray-800">
              {moment(data?.createdAt).format("MM/DD/YYYY  hh:mmA [GMT]Z")}
            </div>
          </div>

          <div>
            <div className="text-xs text-gray-500">Original Order Id</div>
            <a
              target="_blank"
              rel="noreferrer"
              href={`/order/flight/ticket/detail/${booking?.bookingId}?page=Bookings`}
              className="mt-1 text-sm text-primary1 cursor-pointer hover:underline"
            >
              {booking?.bookingId}
            </a>
          </div>

          <div>
            <div className="text-xs text-gray-500">Refund Order ID</div>
            <div className="mt-1 text-sm text-primary1 cursor-pointer hover:underline">
              {data?.orderId}
            </div>
          </div>

          <div>
            <div className="text-xs text-gray-500">GDS PNR</div>
            <div className="mt-1 text-sm text-gray-800">{booking?.pnr}</div>
          </div>

          <div>
            <div className="text-xs text-gray-500">Airline PNR</div>
            <div className="mt-1 text-sm text-gray-800">{airlinePnr || "-"}</div>
          </div>

          <div>
            <div className="text-xs text-gray-500">Ticket number</div>
            <div className="mt-1 text-sm text-gray-800">
              {(booking?.travelers || [])
                .filter((t) => (data?.passengerIds || []).includes(t?.id))
                .flatMap((t) => t?.ticketNumbers || [])
                .filter(Boolean)
                .join(" | ") || "-"}
            </div>
          </div>

          <div>
            <div className="text-xs text-gray-500">Refund type</div>
            <div className="mt-1 text-sm text-gray-800">
              {data?.refundType || "-"}
              {data?.reason ? ` · ${data.reason}` : ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RefundConfirmationOrderIdContainer;
